export default {
  cn: [
    {
      version: '1.0',
      time: '2018.07.05',
      changes: [
        '开发并发布基于 <strong>Vue2</strong> 的 <code>v-playback</code> 插件'
      ]
    }
  ],

  en: [
    {
      version: '1.0',
      time: '2018.07.05',
      changes: [
        'develop and publish <code>v-playback</code> plugin for <strong>Vue2</strong>'
      ]
    }
  ]
}
